module.exports = __webpack_public_path__ + "img/1.776f7448.jpg";